import React from "react";
import { Compass, Truck, CreditCard, Fuel } from "lucide-react";

export const SurveyIntro = ({ onStart }) => {
  return (
    <section
      className="bg-hero-gradient text-white relative overflow-hidden"
      data-testid="survey-intro-section"
    >
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#ecac1f]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-white/5 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 lg:py-24 relative">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-bar" />
            <span className="text-[#ecac1f] text-sm font-bold tracking-[0.18em] uppercase">
              Find Your Fit
            </span>
          </div>
          <h1
            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-5"
            data-testid="intro-title"
          >
            Fuel Needs <br className="hidden sm:block" />
            <span className="text-[#ecac1f]">Survey</span>
          </h1>
          <p
            className="text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed"
            data-testid="intro-subtitle"
          >
            Answer a few quick questions and we'll match you to the best
            Ricochet fuel solution for your operation — bulk delivery, onsite
            fueling, fuel cards, or a smart combination.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 max-w-2xl">
            {[
              { icon: Truck, title: "Bulk Delivery", sub: "Scheduled to your tanks" },
              { icon: Fuel, title: "Onsite Fueling", sub: "We come to your fleet" },
              { icon: CreditCard, title: "Fuel Cards", sub: "Nationwide acceptance" },
            ].map(({ icon: Icon, title, sub }) => (
              <div
                key={title}
                className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl px-4 py-3"
                data-testid={`intro-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="shrink-0 w-9 h-9 rounded-lg bg-[#ecac1f] text-[#2a1f4a] grid place-items-center">
                  <Icon className="w-4 h-4" />
                </div>
                <div className="leading-tight">
                  <div className="font-display text-base">{title}</div>
                  <div className="text-xs text-white/70 uppercase tracking-wider">
                    {sub}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              type="button"
              onClick={onStart}
              className="btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-sm font-bold"
              data-testid="intro-start-button"
            >
              Start the survey
              <Compass className="w-4 h-4" />
            </button>
            <span className="text-xs text-white/70 uppercase tracking-[0.18em]">
              Takes ~60 seconds
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SurveyIntro;
